import { catchError } from 'rxjs/operators';
import { ApiService } from 'src/app/shared/services/api.service';
import { HelperService } from 'src/app/shared/services/helper.service';
import * as i0 from "@angular/core";
import * as i1 from "../../shared/services/api.service";
import * as i2 from "../../shared/services/helper.service";
var PropertyTagNfcsService = /** @class */ (function () {
    /**
     * Class constructor
     */
    function PropertyTagNfcsService(apiService, helperService) {
        this.apiService = apiService;
        this.helperService = helperService;
    }
    /**
     * Create a new Tag NFC
     *
     * @since 1.0.0
     *
     * @param propertyId Property ID
     * @param data Tag NFC data
     * @returns Observable<any>
     */
    PropertyTagNfcsService.prototype.create = function (propertyId, data) {
        return this.apiService.apiCall('POST', "property-tag-nfcs/" + propertyId, data);
    };
    /**
     * Get all Tag NFC list of property
     *
     * @since 1.0.0
     *
     * @param [start] Query left offset
     * @param [limit] Results number
     * @param [sort] Sorting field name
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering object with fildering data string
     */
    PropertyTagNfcsService.prototype.getPropertyTagNFCList = function (propertyId, start, limit, sort, sortVersus, search) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall('GET', "property-tag-nfcs/property/" + propertyId, params);
    };
    /**
     * Get an exportation file of all Tag NFC of property
     *
     * @since 1.0.0
     */
    PropertyTagNfcsService.prototype.getExportPropertyComplete = function (propertyId) {
        var _this = this;
        return this.apiService.apiCall('GET', "property-tag-nfcs/property/export-complete/" + propertyId, {}, { responseType: 'blob' })
            .pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    /**
     * Get an exportation file of all Tag NFC of property
     *
     * @since 1.0.0
     */
    PropertyTagNfcsService.prototype.getExportPropertyShort = function (propertyId) {
        var _this = this;
        return this.apiService.apiCall('GET', "property-tag-nfcs/property/export-short/" + propertyId, {}, { responseType: 'blob' })
            .pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    /**
     * Update fields with given tagId
     *
     * @since 1.0.0
     *
     * @param tagId ID of property to update
     */
    PropertyTagNfcsService.prototype.updateFields = function (tagId, data) {
        return this.apiService.apiCall('PATCH', "property-tag-nfcs/" + tagId, data);
    };
    /**
     * Delete a Tag NFC.
     *
     * If the tag has already been used to record entrances/exits, the back-end
     * requires an admin to also provide `newTagNfcId`: the id of another Tag
     * NFC of the same property onto which those records get moved before the
     * deletion is performed.
     *
     * @since 1.0.0
     *
     * @param tagId ID of the Tag NFC to delete
     * @param [newTagNfcId] ID of the replacement Tag NFC of the same property
     */
    PropertyTagNfcsService.prototype.delete = function (tagId, newTagNfcId) {
        var extraOptions = newTagNfcId ? { body: { newTagNfcId: newTagNfcId } } : undefined;
        return this.apiService.apiCall('DELETE', "property-tag-nfcs/" + tagId, undefined, extraOptions);
    };
    PropertyTagNfcsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PropertyTagNfcsService_Factory() { return new PropertyTagNfcsService(i0.ɵɵinject(i1.ApiService), i0.ɵɵinject(i2.HelperService)); }, token: PropertyTagNfcsService, providedIn: "root" });
    return PropertyTagNfcsService;
}());
export { PropertyTagNfcsService };
